module.exports = __webpack_public_path__ + "static/media/ReportsWitness.f5f785fd.webp";